"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _icon = _interopRequireDefault(require("./icon"));

var _iconsModule = _interopRequireDefault(require("./icons.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoIcon = function InfoIcon(props) {
  var id = props.id;
  return _react.default.createElement(_icon.default, {
    id: id ? id : null,
    className: _iconsModule.default["icon-info"]
  }, _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", {
    id: id ? "".concat(id, "_title") : null
  }, "info"), _react.default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _react.default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _react.default.createElement("circle", {
    className: "svg-info",
    cx: "10",
    cy: "5.64",
    r: "1.09"
  }), _react.default.createElement("path", {
    className: "svg-info",
    d: "M10,7.81A1.09,1.09,0,0,0,8.91,8.9v5.46a1.09,1.09,0,1,0,2.19,0V8.9A1.09,1.09,0,0,0,10,7.81Z"
  }), _react.default.createElement("path", {
    className: "svg-info",
    d: "M10,1a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-1A10,10,0,1,0,20,10,10,10,0,0,0,10,0Z"
  })))));
};

var _default = InfoIcon;
exports.default = _default;